import * as React from 'react';

type CollapseMenuButtonProps = {
  setCollapsed: () => void;
  showCollapseDrawer: boolean;
};

const CollapseMenuButton = ({
  setCollapsed,
  showCollapseDrawer,
}: CollapseMenuButtonProps) => {
  if (showCollapseDrawer) {
    return (
      <>
        <div
          className="collapse-menu-btn collapse-menu-btn-backdrop"
          onClick={(event) => {
            event.stopPropagation();
          }}
          style={{
            background: 'rgba(0, 0, 0, 0.5)',
            cursor: 'default',
            transition:
              'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1), visibility 225ms cubic-bezier(0.4, 0, 0.2, 1)',
            zIndex: 2,
          }}
        />
        <button
          type="button"
          className="collapse-menu-btn"
          onClick={setCollapsed}
          style={{ zIndex: 1 }}
        />
      </>
    );
  }

  return null;
};

export default CollapseMenuButton;
